import {
    AuthSignUpConfirmPhoneSubPage,
    AuthSignUpConfirmPhoneSubtitle,
    AuthSignUpAmplifyImageWrapper,
    ProfileAuthSignInImage,
    AuthSignUpReadytoGoTitle,
    AuthSignUpCompleteExploreButton,
} from "../authBarStyling";
import { userModelSelector } from "../../../state/selectors/userModel";
import { signInMenuActivatedSelector } from "../../../state/selectors/navbarToggle";
import { useRecoilState } from "recoil";

interface WelcomePopupProps {
    profilePicture: string;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({ profilePicture }) => {
    const [userModel] = useRecoilState(userModelSelector);
    const [, setSignInMenuActivated] = useRecoilState(signInMenuActivatedSelector);
    return (
        <div style={{ height: "100%" }}>
            <AuthSignUpConfirmPhoneSubPage pageName={"WelcomePopup"}>
                <AuthSignUpAmplifyImageWrapper style={{ width: "128px", height: "128px" }}>
                    <ProfileAuthSignInImage style={{ width: "128px", height: "128px" }} src={profilePicture} alt="Profile photo" />
                </AuthSignUpAmplifyImageWrapper>
                <AuthSignUpReadytoGoTitle>Welcome to Anystay, {userModel ? userModel.firstName : "Guest"}</AuthSignUpReadytoGoTitle>
                <AuthSignUpConfirmPhoneSubtitle>You're on your way to our homes and rooms for rent.</AuthSignUpConfirmPhoneSubtitle>
                <AuthSignUpCompleteExploreButton
                    type="button"
                    onClick={() => {
                        setSignInMenuActivated(false);
                    }}
                >
                    Start exploring
                </AuthSignUpCompleteExploreButton>
            </AuthSignUpConfirmPhoneSubPage>
        </div>
    );
};

export default WelcomePopup;
